import jwt_decode from 'jwt-decode';
import { TOKEN_NAME } from '../constants';

const getToken = () => localStorage.getItem(TOKEN_NAME);
export const isValidToken = () => {
  const token = getToken();
  if (token && Date.now() < jwt_decode(token).exp * 1000) return true;
  return false;
};

export const getUser = () => {
  if (isValidToken) {
    const {
      user: { password, ...rest },
    } = jwt_decode(getToken());
    return rest;
  }
  return null;
};
